export const JOB_SCHEDULES = "JOB_SCHEDULES"

export const SYNC_JOB_SHEDULES_ITEMS_FETCH_LIST =
  "SYNC_JOB_SHEDULES_ITEMS_FETCH_LIST"
export const FEED_JOB_SHEDULES_ITEMS_FETCH_LIST =
  "FEED_JOB_SHEDULES_ITEMS_FETCH_LIST"
